import React from 'react';
import SalesByWaitersContent from './SalesByWaitersContent';

const SalesByWaiters = () => <SalesByWaitersContent />;

export default SalesByWaiters;
